import { BaseEntityPage } from '../../components/common';
import ProvincesOriginalContent from './components/ProvincesOriginalContent';

export function ProvincesOriginalPage() {
	return (
		<BaseEntityPage ContentComponent={ProvincesOriginalContent} />
	);
}
